<template>
  <div class="content" :class="{ active: !logoShow }">
    <div class="page">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>
<script>
import Signal from "../../assets/js/signal.js";
export default {
  data() {
    return {
      logoShow: true,
    };
  },
  mounted() {
    var ts = this;
    Signal.$on("logoMenu", function (res) {
      console.log("nav", res);
      ts.logoShow = res;
    });
  },
};
</script>

<style lang='less' scoped>
.content {
  min-width: 1000px;
  background: #f2f5f9;
  position: absolute;
  top: 112px;
  left: 286px;
  bottom: 0px;
  right: 0;
  .page {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }
  &.active {
    left: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Content.vue